<section [ngClass]="[styles.flexColumn, styles.chat]">

	<div class="vb-scrollbar" [ngClass]="styles.scrollContainer" vbScrollToBottom>
		<div [ngClass]="[styles.flexColumn, styles.messageContainer]">

			@for (msg of chatMessages(); track msg) {
				@if (msg.author === MessageAuthor.USER) {
					<video-ai-assistant-user-message [user]="user" [message]="msg"></video-ai-assistant-user-message>
				} @else {
					<video-ai-assistant-bot-message [message]="msg" (onTimeClicked)="seekTime($event)" (onCopyClicked)="copyToClipboard($event)"></video-ai-assistant-bot-message>
				}
			}
				
			@if (VideoAiAssistantService.chatState().isWaitingForChatResponse) {
				<div [ngClass]="[
						styles.flexRow,
						styles.message,
						styles.botMessage,
						styles.waitingChatMessage
					]">
					<vb-profile-picture [placeholderIconClass]="'lightbulb'" size="large"></vb-profile-picture>
					<div [ngClass]="styles.flexColumn">
						<div [ngClass]="styles.header">
							<span>{{ 'UI_AI' | translate }}</span>
						</div>
						<div [ngClass]="[styles.flexColumn]">
							<vb-ui-spinner></vb-ui-spinner>
							@if (VideoAiAssistantService.chatState().showStillWorkingMessage) {
								<span [ngClass]="styles.stillWorking">{{ 'Media_Videos_Assistant_StillWorking' | translate }}</span>
							}
						</div>
					</div>
				</div>
			}

		</div>
	</div>

	<form #questionForm="ngForm" (submit)="submitQuestion()">
		<div [ngClass]="[styles.flexColumn, styles.formContainer]">
			<div [ngClass]="styles.inputWrapper">
				<input type="text" autocomplete="off" name="questionText" [(ngModel)]="question" [placeholder]="'Media_Videos_Assistant_Placeholder' | translate" vbUiTextInput/>
				<button type="submit" [attr.aria-label]="'Send' | translate" [disabled]="VideoAiAssistantService.chatState().isWaitingForChatResponse || question?.trim().length === 0" vbBtnPrimary>
					{{ 'UI_Submit' | translate }}
				</button>
			</div>
			<div [ngClass]="[styles.flexRow, styles.footer]">
				<span>{{ 'Media_Videos_Assistant_Warning' | translate }}</span>
			</div>
		</div>
	</form>

</section>
